import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPatch, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  ABTest,
  ABTestCreateRequest,
  ABTestEndRequest,
  ABTestsResponse,
  ActiveABTestResponse,
  UpdateABTestTrafficRequest,
} from './types';

const VERSION = 'v2';

export const getABTests = (accountId: string, projectId: string) => {
  return doGet<ABTestsResponse>(
    generateNextPath(ENDPOINTS.AB_TESTS, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    { version: VERSION },
  );
};

export const getActiveABTest = (accountId: string, projectId: string) => {
  return doGet<ActiveABTestResponse>(
    generateNextPath(ENDPOINTS.ACTIVE_AB_TEST, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    { version: VERSION },
  );
};

export const createABTest = ({
  accountId,
  projectId,
  body,
}: {
  accountId: string;
  projectId: string;
  body: ABTestCreateRequest;
}) => {
  return doPost<ABTest>(
    generateNextPath(ENDPOINTS.AB_TESTS, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    body,
    { version: VERSION },
  );
};

export const endABTest = ({
  accountId,
  projectId,
  abTestId,
  body,
}: {
  accountId: string;
  projectId: string;
  abTestId: string;
  body: ABTestEndRequest;
}) => {
  return doDelete<ABTest>(
    generateNextPath(ENDPOINTS.AB_TEST, { accountId, projectId, abTestId }),
    LOGGER_TYPE.JUPITER,
    body,
    { version: VERSION },
  );
};

export const updateABTestTraffic = ({
  accountId,
  projectId,
  abTestId,
  body,
}: {
  accountId: string;
  projectId: string;
  abTestId: string;
  body: UpdateABTestTrafficRequest;
}) => {
  return doPatch<ABTest>(
    generateNextPath(ENDPOINTS.AB_TEST, { accountId, projectId, abTestId }),
    LOGGER_TYPE.JUPITER,
    body,
    { version: VERSION },
  );
};
